// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__247D9","largestCol":"styles_largestCol__JfJzY","smallestCol":"styles_smallestCol__1lvCT"};